import {
  ACCEPT_TERMS,
  COLLECT_MOVE_IN_COSTS,
  EDIT_ACCOUNT_INFO,
  EDIT_DUE_DATE,
  EDIT_INVITE_TENANT,
  EDIT_MOVE_IN_COSTS,
  EDIT_PAYMENT_SETTINGS,
  EDIT_PAYMENT_TERM,
  EDIT_RENT_AMOUNT,
  EDIT_TAX_VERIFICATION,
  SAVE_ACCOUNT_INFO,
  SAVE_ENCODED_LEASE_ID,
  SAVE_EXPERIAN_ERROR_STATE,
  SAVE_IDENTITY_VERIFICATION,
  SAVE_INVITE_TENANT,
  SAVE_LEASE_ID,
  SAVE_MOVE_IN_COST_SETTINGS,
  SAVE_PAYMENT_SETTINGS,
  SAVE_RENTAL_PROTECTION_FEATURE,
  SETUP_NEW_TERM,
  START_NEW_TERM,
} from '@rental-manager/constants/ActionConstants';

export const acceptTerms = ({ propertyId }) => ({
  type: ACCEPT_TERMS,
  propertyId,
});

export const collectMoveInCosts = ({ propertyId }) => ({
  type: COLLECT_MOVE_IN_COSTS,
  propertyId,
});

export const savePaymentSettings = ({ propertyId, paymentSettings }) => ({
  type: SAVE_PAYMENT_SETTINGS,
  propertyId,
  paymentSettings,
});

export const saveMoveInCostsSettings = ({ propertyId, ...payload }) => ({
  type: SAVE_MOVE_IN_COST_SETTINGS,
  propertyId,
  payload,
});

export const saveAccountInfo = ({ propertyId, accountInfo }) => ({
  type: SAVE_ACCOUNT_INFO,
  propertyId,
  accountInfo,
});

export const saveIdentityVerificationInfo = ({ propertyId, identityVerificationInfo }) => ({
  type: SAVE_IDENTITY_VERIFICATION,
  propertyId,
  identityVerificationInfo,
});

export const saveExperianErrorState = ({ propertyId, identityCheckResponse }) => ({
  type: SAVE_EXPERIAN_ERROR_STATE,
  propertyId,
  identityCheckResponse,
});

export const saveTenantInvitationInfo = ({ propertyId, tenantInvitationInfo }) => ({
  type: SAVE_INVITE_TENANT,
  propertyId,
  tenantInvitationInfo,
});

export const editPaymentSettingsPage = ({ propertyId }) => ({
  type: EDIT_PAYMENT_SETTINGS,
  propertyId,
});

export const editMoveInCostsPage = ({ propertyId }) => ({
  type: EDIT_MOVE_IN_COSTS,
  propertyId,
});

export const editRentAmountPage = ({ propertyId }) => ({
  type: EDIT_RENT_AMOUNT,
  propertyId,
});

export const editDueDatePage = ({ propertyId }) => ({
  type: EDIT_DUE_DATE,
  propertyId,
});

export const editPaymentTermPage = ({ propertyId }) => ({
  type: EDIT_PAYMENT_TERM,
  propertyId,
});

export const editAccountInfoPage = ({ propertyId }) => ({
  type: EDIT_ACCOUNT_INFO,
  propertyId,
});

export const editTaxVerificationPage = ({ propertyId }) => ({
  type: EDIT_TAX_VERIFICATION,
  propertyId,
});

export const editInviteTenantPage = ({ propertyId }) => ({
  type: EDIT_INVITE_TENANT,
  propertyId,
});

export const startNewTerm = ({ propertyId }) => ({
  type: START_NEW_TERM,
  propertyId,
});

export const setupNewTerm = ({ propertyId, ...data }) => ({
  type: SETUP_NEW_TERM,
  propertyId,
  ...data,
});

export const saveLeaseId = ({ propertyId, leaseId }) => ({
  type: SAVE_LEASE_ID,
  propertyId,
  leaseId,
});

export const saveRentalProtectionFeature = ({ propertyId, rentGuarantee }) => ({
  type: SAVE_RENTAL_PROTECTION_FEATURE,
  propertyId,
  rentGuarantee,
});

export const saveEncodedLeaseId = ({ propertyId, encodedLeaseId }) => ({
  type: SAVE_ENCODED_LEASE_ID,
  propertyId,
  encodedLeaseId,
});
